import cx from 'classnames'

import style from './WidgetLayout.module.scss'
import { useMemo, useRef, useState } from 'react'
import HubWidget, {
  LiveTVWidget,
  MusicWidget,
  RadioWidget,
  VODWidget,
  WeatherWidget,
} from './HubWidget'
import { useLocalStorage } from '../../storage/hooks'

const defaultWidgets = ['radio', 'livetv', 'music', 'weather', 'tvshow']
const LayoutLS = 'cinemo-widgets-hub'

const swapArrayElements = (array, indexA, indexB) => {
  const copy = [...array]
  copy[indexA] = array[indexB]
  copy[indexB] = array[indexA]
  return copy
}

const sizeFromPosition = (position) => {
  if (position < 2) {
    return 'big'
  }
  if (position < 3) {
    return 'medium'
  }
  return 'small';
}

export default function WidgetLayout () {
  const nodeRef = useRef(null)
  const [widgets, setWidgets] = useLocalStorage(LayoutLS, defaultWidgets)
  const [longClick, setLongClick] = useState(false)
  const [activeDrags, setActiveDrags] = useState(false)
  let longPressTO = undefined

  const onStart = (position) => (e) => {
    longPressTO = setTimeout(() => {
      setLongClick(true)
      setActiveDrags(position)
    }, 125)
  }

  const onDrag = (e) => {
    if (!longClick) return false
  }

  const onStop = (e) => {
    clearTimeout(longPressTO)
    if (activeDrags !== false && e.target?.classList?.contains('placeholder')) {
      if (e.target?.dataset?.position !== activeDrags) {
        setWidgets(
          swapArrayElements(widgets, activeDrags, e.target?.dataset?.position),
        )
      }
    }
    setActiveDrags(false)
    setLongClick(false)
  }

  const dragHandlers = {
    onDrag,
    onStop,
    bounds: '.App > div > div',
    position: { x: 0, y: 0 },
  }

  const widgetsJSX = useMemo(() => {
    return widgets.map((widget, pos) => {
      const widgetProps = {
        onStart: onStart(pos),
        nodeRef: nodeRef,
        className: cx({
          'no-pointer-events': activeDrags !== false,
        }),
        'data-position': pos,
        size: sizeFromPosition(pos),
      }

      if (widget === 'livetv') {
        return <LiveTVWidget {...dragHandlers} {...widgetProps} />
      }
      if (widget === 'music') {
        return <MusicWidget {...dragHandlers} {...widgetProps} />
      }
      if (widget === 'radio') {
        return <RadioWidget {...dragHandlers} {...widgetProps} />
      }
      if (widget === 'tvshow') {
        return <VODWidget {...dragHandlers} {...widgetProps} />
      }
      if (widget === 'weather') {
        return <WeatherWidget {...dragHandlers} {...widgetProps} />
      }

      return (
        <HubWidget {...dragHandlers} onStart={onStart(pos)} nodeRef={nodeRef}>
          <div
            className={cx('widget', {
              'no-pointer-events': activeDrags !== false,
            })}
            // onMouseLeave={onPointerUp}
            // onPointerDown={onPointerDown}
            // onPointerUp={onPointerUp}
            data-position={pos}
            ref={nodeRef}
          >
            Widget: {widget}
          </div>
        </HubWidget>
      )
    })
  }, [widgets, dragHandlers])

  return (
    <div className={cx('widgets-grid', style['widgets-grid'],
      { 'grabbing-cursor': activeDrags !== false })}>
      <div
        className={cx('placeholder placeholder--1', style.placeholder)}
        data-position={0}
      >
        {widgetsJSX[0]}
      </div>
      <div
        className={cx('placeholder placeholder--2', style.placeholder)}
        data-position={1}
      >
        {widgetsJSX[1]}
      </div>
      <div
        className={cx('placeholder placeholder--3', style.placeholder)}
        data-position={2}
      >
        {widgetsJSX[2]}
      </div>
      <div
        className={cx('placeholder placeholder--4', style.placeholder)}
        data-position={3}
      >
        {widgetsJSX[3]}
      </div>
      <div
        className={cx('placeholder placeholder--5', style.placeholder)}
        data-position={4}
      >
        {widgetsJSX[4]}
      </div>
    </div>
  )
}
